export const env = {
  npm_package_version: "0.0.0",
};
